import React from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import { connect } from 'react-redux';
import {
  withStyles,
  TextField,
  ListItem,
  Paper,
  InputAdornment,
  Icon,
} from '@material-ui/core';
import Downshift from 'downshift';

import User from '../../widgets/User';
import styles from './styles';

const renderInput = (inputProps) => {
  const {
    InputProps,
    classes,
    selectedItem,
    tenantUsers,
    fieldName,
    error,
    required,
    helperText,
  } = inputProps;

  const allItemSelected = selectedItem.length === tenantUsers.length;

  return (
    <TextField
      label={fieldName}
      fullWidth
      multiline
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      margin="normal"
      className={classes.textField}
      disabled={allItemSelected}
      error={error}
      required={required}
      helperText={helperText}
      FormHelperTextProps={{ component: 'div' }}
      InputProps={{
        ...InputProps,
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput,
        },
      }}
    />
  );
};

const renderChipList = (inputProps, classes) => {
  const {
    selectedItem,
    onRemoveItem,
    tenantUsers,
    readonly,
  } = inputProps;
  return (
    <span className={classes.chipContainer}>

      <InputAdornment position="start">
        <Icon className={classes.inputAdornmentIcon}>people</Icon>
        {
        selectedItem.length > 0
          && selectedItem.filter((item) => item)
            .map((item) => {
              const users = tenantUsers.filter((tenantUser) => item.indexOf(tenantUser.auth0UserId) >= 0);
              const user = users.length > 0
                ? users[0]
                : {
                  auth0UserId: '-1',
                  email: item,
                  firstName: '',
                  lastName: '',
                };
              return (
                <User
                  key={user.auth0UserId}
                  chip
                  user={user}
                  showDelete={!readonly}
                  onDelete={() => onRemoveItem(item)}
                />
              );
            })
        }
      </InputAdornment>

    </span>
  );
};

const renderSuggestion = (params) => {
  const {
    item,
    index,
    itemProps,
    highlightedIndex,
    selectedItem,
  } = params;
  const isHighlighted = highlightedIndex === index;
  const isSelected = selectedItem.indexOf(item.name) > -1;

  return (
    !isSelected && (
      <ListItem
        value={item}
        {...itemProps}
        key={item.id}
        selected={isHighlighted}
        component="div"
        dense
        divider
      >
        <User
          key={item.auth0UserId}
          chip
          user={item}
        />
      </ListItem>
    )
  );
};

const getSuggestions = (
  inputValue,
  itemList,
  selectedItems,
) => itemList.filter((item) => selectedItems.filter((selectedItem) => selectedItem.indexOf(item.auth0UserId) >= 0).length === 0)
  .filter((item) => (item.email.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
    || item.firstName.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
    || item.lastName.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0));

class UserDownshiftComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { inputValue: '' };
  }

  handleChangeInputValue = (inputValue) => {
    this.setState({ inputValue: inputValue || '' });
  }

  render() {
    const {
      classes,
      tenantUsers,
      onRemoveItem,
      readonly,
      fieldName,
      error,
      required,
      helperText,
      ...rest
    } = this.props;
    const { inputValue } = this.state;

    return (
      <Downshift
        onInputValueChange={this.handleChangeInputValue}
        inputValue={inputValue}
        {...rest}
      >
        {
          ({
            getInputProps,
            getItemProps,
            selectedItem,
            highlightedIndex,
            toggleMenu,
            isOpen,
          }) => (
            <div>
              {
              renderInput({
                classes,
                selectedItem,
                tenantUsers,
                error,
                required,
                helperText,
                InputProps: {
                  ...getInputProps({ onClick: () => toggleMenu() }),
                  startAdornment: renderChipList({
                    onRemoveItem,
                    selectedItem,
                    readonly,
                    tenantUsers,
                  }, classes),
                },
                fieldName,
              })
            }

              {isOpen && (
                <Paper className={classes.paper} square>
                  {sortBy(getSuggestions(inputValue, tenantUsers, selectedItem), ['firstName', 'lastName', 'email']).map((item, index) => renderSuggestion({
                    item,
                    index,
                    itemProps: getItemProps({ item }),
                    highlightedIndex,
                    selectedItem,
                  }))}
                </Paper>
              )}
            </div>
          )
        }
      </Downshift>
    );
  }
}

UserDownshiftComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
  tenantUsers: PropTypes.array,
  fieldName: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.any,
};

UserDownshiftComponent.defaultProps = {
  readonly: false,
  tenantUsers: [],
  fieldName: '',
  required: false,
  error: false,
  helperText: '',
};

export const mapStateToProps = (state) => ({ tenantUsers: state.tenant.tenantUsers });

export default connect(mapStateToProps)(withStyles(styles)(UserDownshiftComponent));
